/* Reducers for UI component of Redux state. See src/interfaces/state/index.ts for more information */
import { IUi, STATUS } from '../../interfaces';
import { Interfaces, Constants } from '../../actions/ui';
import { SETTINGS } from '@logicmanager/common';
export type ActionType = Interfaces.ISetSubmitted
                         & Interfaces.ISetTabStatus
                         & Interfaces.ISetSettings
                         & Interfaces.ISetLogoUrl;

const initial: IUi = {
    isFetching: false,
    isSubmitted: false,
    status: STATUS.Success,
    tabOpened: {},
    hasVisibilityRules: true,
    isCaptchaEnabled: false,
    useHeaderLogo: false,
    logoUrl: null
};

export function ui(state: IUi = initial, action: ActionType): IUi {
    switch (action.type) {
        case Constants.FETCH_REQUEST:
            return {
                ...state,
                isFetching: true,
                status: STATUS.Fetching
            };
        case Constants.FETCH_SUCCESS:
            return {
                ...state,
                isFetching: false,
                status: STATUS.Success
            };
        case Constants.FETCH_FAILURE:
            return {
                ...state,
                isFetching: false,
                status: STATUS.Failure
            };
        case Constants.NO_VISIBILITY_RULES:
            return {
                ...state,
                hasVisibilityRules: false
            };
        case Constants.SET_SUBMITTED:
            return {
                ...state,
                isSubmitted: action.isSubmitted
            };
        case Constants.SET_TAB_OPENED:
            return {
                ...state,
                tabOpened: {
                    ...state.tabOpened,
                    [action.tabId]: action.opened
                }
            };
        case Constants.SET_SETTINGS:
            return {
                ...state,
                // captcha is enabled by default so we won't disable it
                // unless we get the setting value as 0 (as in boolean false)
                isCaptchaEnabled: action.settings[SETTINGS.EXTERNAL_USE_CAPTCHA] !== '0',
                useHeaderLogo: action.settings[SETTINGS.USE_HEADER_LOGO] === '1'
            };
        case Constants.SET_LOGO_URL:
            return {
                ...state,
                logoUrl: action.logoUrl
            };
        default:
            return state;
    }
}
